import SETTINGS from '../../settings';

/* eslint-disable no-undef */
const TAG = 'Canny';

const CannyScript = {
  identify(userId, email, name) {
    try {
      Canny('identify', {
        appID: SETTINGS.SCRIPTS.CANNY_APP_ID,
        user: {
          id: userId,
          email,
          name: name ?? email,
        },
      });
    } catch (e) {
      console.log(TAG, 'identify', e);
    }
  },
};

export default CannyScript;
